import { collection, setDoc, doc, getDoc, updateDoc, query, getDocs } from 'firebase/firestore';
import { Coach, AvailableTimeMap, AvailableTime } from '../types';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { convertToAvailableTimeMap } from '../utils';

export const getCoachListFirebase = async () => {
    const coachSnapshot = await getDocs(query(collection(db, DbCollections.Coach)));
    const coaches = [] as Coach[];
    coachSnapshot.forEach((doc) => {
        const data = doc.data();
        const availableTime = convertToAvailableTimeMap(data?.availableTime);
        coaches.push({
            description: data.description,
            image: data.image,
            phoneNumber: data.phoneNumber,
            uid: data.uid,
            availableTime: availableTime,
        });
    });
    return coaches;
};

export const updateCoachAvailableTimeFirebase = async (uid: string, availableTimeMap: AvailableTimeMap) => {
    const coach = await getDoc(doc(db, DbCollections.Coach, uid));

    if (!coach.exists()) throw new Error(`Coach doesn't for user ${uid}`);

    const availableTimeList = Object.keys(availableTimeMap).reduce((acc, cur: string) => {
        return [...acc, ...availableTimeMap[cur]];
    }, [] as AvailableTime[]);
    const availableTime = availableTimeList.reduce((acc, cur: AvailableTime) => {
        const from = cur.time.split('-')[0];
        const hoursAndMinutes = from.split(':');
        const date = new Date(cur.date);
        date.setHours(Number(hoursAndMinutes[0]), Number(hoursAndMinutes[1]), 0);
        return { ...acc, [cur.id]: { date, time: cur.time } } as AvailableTimeMap;
    }, {});
    await updateDoc(doc(db, DbCollections.Coach, uid), { availableTime });
    return availableTimeMap;
};
export const addCoachInfoFirebase = async (
    description: Record<string, string>,
    image: string,
    phoneNumber: string,
    uid: string,
) => {
    const coachRef = doc(collection(db, DbCollections.Coach), uid);
    const coach = await getDoc(coachRef);

    if (coach.exists()) {
        await updateDoc(coachRef, { image, description, phoneNumber, uid });
    } else {
        await setDoc(coachRef, { description, image, phoneNumber, uid });
    }
    return { description, image, phoneNumber };
};
